import { render, staticRenderFns } from "./ZoneTabs.vue?vue&type=template&id=cf9abc3e&"
import script from "./ZoneTabs.vue?vue&type=script&lang=js&"
export * from "./ZoneTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports